// NotFoundPage.js
import React from 'react';
import Header from '../components/Header';

const NotFoundPage = () => {
  return (
    <div>
      {/* <Header /> */}
      <div style={notFoundContainerStyle}>
        <h2 style={notFoundHeadingStyle}>404 NOT FOUND</h2>
      </div>
    </div>
  );
};

const notFoundContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh)', // Adjusted for the header height
    backgroundColor: '#FFEBEE', // Reddish tone background color
    border: '2px solid #D32F2F', // Red color border
    padding: '20px', // Padding inside the box
  };
  
  const notFoundHeadingStyle = {
    color: '#D32F2F', // Red color for the heading
    fontSize: '36px', // Larger font size
    margin: '0', // Remove default margin for better styling
  };

export default NotFoundPage;
